/* jshint esversion: 6 */
import React from 'react';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';

class ChooserButton extends React.Component {

    render() {
        let name = this.props.subaccount.name,
            subType = null,
            avatar = (
                <div className='avatar-bg'>
                    <i className='fa fa-user'></i>
                </div>
            ),
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.serviceID)],
            buttonClass = 'chooser-button unselected',
            serviceClass = ConstantMixin.getIconIndexByCode(this.props.serviceID),
            clickAction = (e) => {
                this.props.buttonDecorator(e);
                this.props.onSubaccountClick(e);
            },
            isSelected = this.props.selectedSocials.indexOf(this.props.subaccount[this.props.idField].toString()),
            constants = this.props.app.config.constants;

        if (this.props.serviceID === constants.POST_SVC_FACEBOOK && this.props.subaccount.type.match(/profile/i)) {
            Icon = IconFactory.alert;
            buttonClass += " static";
            clickAction = null;
        }

        if (this.props.subaccount.inuseStatus) {
            if (this.props.subaccount.inuseStatus === 1 || this.props.subaccount.inuseStatus === true) {
                //buttonClass = buttonClass.replace('unselected', 'inuse');
                buttonClass += " static";
                clickAction = null;
            }
        } else if ((this.props.subaccount.verified !== undefined && this.props.subaccount.verfied === 0) ||
                    (this.props.subaccount.canPost !== undefined && this.props.subaccount.canPost === 0)) {
            buttonClass += " static";
            clickAction = null;
        }

        if (isSelected !== -1 && clickAction !== null) {
            buttonClass = buttonClass.replace("unselected", "");
        }

        if (this.props.subaccount.picture) {
            avatar = (
                <div className='avatar-bg'>
                    <img src={this.props.subaccount.picture} className='avatar-img' alt='Account Avatar'/>
                </div>
            );
        }

        if (this.props.subaccount.type) {
            subType = (
                <div className={'chooser-type'}>
                    {this.props.subaccount.type}
                </div>
            );
        }

        return (
            <div>
                <div className={buttonClass}
                    data-id={this.props.subaccount[this.props.idField]}
                    data-group={this.props.subaccount.groupConnect !== undefined ? this.props.subaccount.groupConnect : false}
                    data-type={this.props.subaccount.type}
                    role='button'
                    aria-label={`connect ${this.props.subaccount.name}`}
                    onClick={clickAction}>
                    <div className='avatar-group'>
                        <div className={`social-avatar large button outlined ${serviceClass}`}>
                            {avatar}
                        </div>
                        <div className='service-icon'>
                            <Icon inactive={isSelected === -1 ? true : false} white={true}/>
                        </div>
                    </div>
                    <div className='social-label' title={this.props.subaccount.name}>
                        {this.props.subaccount.name}
                    </div>
                </div>
                {subType}
            </div>
        );
    }
}

ChooserButton.displayName = "ChooserButton";

ChooserButton.defaultProps = {
    subaccount: {
        id: 0,
        name: '',
        picture: '',
        type: '',
        inuse: false
    },
    idField: 'id',
    selectedSocials: []
};

export default ChooserButton;
